import React, { useState } from "react";

export default ({
  onTextExtracted,
  placeholder,
}: {
  onTextExtracted: any;
  placeholder?: string;
}) => {
  const [inputText, setInputText] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (event) => {
    setInputText(event.target.value);
  };

  const handleAnalyzeClick = async () => {
    setIsLoading(true);
    onTextExtracted(inputText);
    setIsLoading(false);
  };

  return (
    <section style={{ height: "100%", width: "100%" }}>
      <div style={{ marginBottom: "20px" }}>
        <textarea
          value={inputText}
          onChange={handleInputChange}
          rows={10}
          style={{ width: "100%", padding: "10px", fontSize: "16px" }}
          placeholder={!!placeholder ? placeholder : "Enter text here..."}
        />
      </div>
      <button onClick={handleAnalyzeClick} disabled={isLoading}>
        {isLoading ? "Analyzing..." : "Analyze Text"}
      </button>
    </section>
  );
};
